import * as React from "react"
import * as Button from "./button"
import {Theme} from "./theme"
import {DispatchableAsync, DispatcherActionLike} from "../utils";
import {Action} from "redux";

export interface FormProps extends React.Props<Form> {
	isSubmitting?: boolean
	onSubmit: () => void
	onCancel?: () => void
	hasSave?: boolean|string
	hasCancel?: boolean
	theme?: Theme
	onSaveReturn?: () => void
	saveReturnLabel?: string
}

export class Form extends React.Component<FormProps, {}> {
	static childContextTypes = {
		theme: React.PropTypes.string.isRequired
	}

	getChildContext() {
		return {theme: this.props.theme || "admin"}
	}

	render() {
		let leftButtons:JSX.Element[]  = []
		let rightButtons:JSX.Element[] = []

		if (this.props.hasCancel) {
			leftButtons.push(<CancelButton key="cancel" onClick={this.props.onCancel} />)
		}

		const hasSave = this.props.hasSave
		if (hasSave !== false) {
			const label: string|undefined = typeof hasSave === "string" ? hasSave : undefined
			rightButtons.push(<SaveButton key="save" label={label} isInProgress={this.props.isSubmitting} />)
		}

		const onSaveReturn = this.props.onSaveReturn
		if (onSaveReturn !== undefined) {
			const saveReturnLabel = this.props.saveReturnLabel
			rightButtons.push(
				<SaveButton
					key="saveReturn"
					label={saveReturnLabel !== undefined ? saveReturnLabel : 'Save / Return'}
					onClick={onSaveReturn}
					isInProgress={this.props.isSubmitting}
				/>
			)
		}

		const rightButtonsName = rightButtons.length > 1 ? "sbFormButtonsRight" : "sbFormButtonRight"

		const onSubmit = (e:React.FormEvent<{}>) => {
			// prevent the form from actually submitting
			e.preventDefault()
			e.stopPropagation()
			this.props.onSubmit()
		}

		return <form className="sbForm" onSubmit={onSubmit}>
			{this.props.children}
			<table style={{width:"100%"}} className="sbFormButtonsOuter">
				<tbody>
					<tr>
						<td className="sbFormButtonsLeft">{leftButtons}</td>
						<td className={rightButtonsName} style={{textAlign: "right", nowrap: "nowrap"}}>
							{this.props.isSubmitting && <span><img className="loadingImage" src="/sb/static/images/loadergif.gif"/></span>}
							{rightButtons}
						</td>
					</tr>
				</tbody>
			</table>
		</form>
	}
}

export const saveReturnCallback = <S extends {}>(
	dispatch: DispatcherActionLike<Action, void>,
	save: DispatchableAsync<Action, S, void>,
	returnUrl:string
): DispatchableAsync<Action, S, void> => async (
	dispatch: DispatcherActionLike<Action, void>,
	getState: () => S
) => {
	await save(dispatch, getState)
	window.location.assign(returnUrl)
}

export interface ManagedFormProps extends React.Props<ManagedForm> {
	onSubmit: () => Promise<void>
	onCancel?: () => void
	hasSave?: boolean
	hasCancel?: boolean
}

export interface ManagedFormState {
	isInProgress?: boolean
}

export class ManagedForm extends React.Component<ManagedFormProps, ManagedFormState> {
	constructor(props?: ManagedFormProps, context?: any) {
		super(props, context);
		this.state = {
			isInProgress: false
		}
	}

	render() {
		const onSubmit = () => {
			this.setState({isInProgress: true})
			const onDone = () => { this.setState({isInProgress: false}) }

			// Notifying the user of the rejected promise should have been done by this.props.onSubmit()
			// We just need to set isInProgress back to false
			this.props.onSubmit().then(onDone, onDone)
		}

		return <Form isSubmitting={this.state.isInProgress} onSubmit={onSubmit} hasSave={this.props.hasSave} hasCancel={this.props.hasCancel} onCancel={this.props.onCancel}>
			{this.props.children}
		</Form>
	}
}

export class Heading extends React.Component<React.Props<Heading>, {}> {
	render() {
		return <h2 className="sbHeading">{this.props.children}</h2>
	}
}

const buttonClasses = "sbFormButton sbRoundedEdges"

type CancelButtonProps = {
	onClick?: () => void
}

const CancelButton = (props: CancelButtonProps) => {
	return <Button.Button className={buttonClasses} onClick={props.onClick}>Cancel</Button.Button>
}

type SaveButtonProps = {
	isInProgress?: boolean
	label?: string
	onClick?: () => void
}

const SaveButton = (props: SaveButtonProps) => {
	const label = props.label || "Save"
	const classProps = {className: buttonClasses}
	const disabledProps = props.isInProgress ? {disabled: props.isInProgress} : {}
	const typeProps = props.onClick
		? {
			type: Button.Type.button,
			onClick: props.onClick
		} : {
			type: Button.Type.submit
		}

	return <span>
		<Button.Button {...classProps} {...typeProps} {...disabledProps}>{label}</Button.Button>
	</span>
}



// WEBPACK FOOTER //
// ./src/lib/sbhtml/form.tsx